import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import {
  getcandidateSubmissionsAction,
  getJobDetailsAction,
  selectedJobAction,
  selectedSubmissionAction,
} from "../../redux/action";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  Avatar,
  Badge,
  Box,
  ListItemButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Grid,
} from "@mui/material";
import {
  BusinessCenterRounded,
  CancelRounded,
  CheckCircleRounded,
} from "@mui/icons-material";
import HistoryIcon from "@mui/icons-material/History";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import moment from "moment";
import { userSelector } from "../../user-redux/selector";
import { styled } from "@mui/material/styles";
import axios from "axios";
import Key from "../../../clientVariables.json";

const AdminRecruiterSubmissions = ({
  setSharedData,
  viewStep,
  setViewStep,
  clearViewStep,
  handleCompanyClick,
}) => {
  const dispatch = useDispatch();
  const {
    candidateSubmissions,
    selectedCandidate,
    selectedSubmission,
    myRecruiters,
    assignedCandidates,
  } = useSelector(appSelector);
  const { user } = useSelector(userSelector);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(200);
  const [hasMore, setHasMore] = useState(true);
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState({});
  const [selectedJobInfo, setSelectedJobInfo] = useState({});

  const theme = useTheme();
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const { selectedRecruiter } = useSelector(appSelector);

  const visibleSubmissions = useMemo(() => {
    return Array.isArray(candidateSubmissions)
      ? candidateSubmissions.filter(
        (s) => Number(s?.bench_status_id) > 3
      )
      : [];
  }, [candidateSubmissions]);


  useEffect(() => {
    if (visibleSubmissions.length > 0) {
      const submission = visibleSubmissions[0];
      dispatch(selectedSubmissionAction(submission));
      dispatch(selectedJobAction(submission));
    } else {
      dispatch(selectedSubmissionAction(null));
    }
  }, [visibleSubmissions, dispatch]);

  useEffect(() => {
    setShowHistory(false);
    setHistory([]);
    setSelectedJobInfo({});
  }, [candidateSubmissions, selectedCandidate?.candidate_id]);

  useEffect(() => {
    if (candidateSubmissions && candidateSubmissions.length < limit) {
      setHasMore(false);
    }
  }, [candidateSubmissions, limit]);

  const handleSelection = (submission) => {
    dispatch(selectedSubmissionAction(submission));
    dispatch(selectedJobAction(submission));
    if (clearViewStep) {
      clearViewStep();
    }
  };

  const fetchMoreData = () => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const getSubmissionsHistory = async (submission) => {
    const loadingKey = `${submission.candidate_id}-${submission.job_id}`;
    setLoadingHistory((prev) => ({ ...prev, [loadingKey]: true }));

    try {
      const result = await axios.post(
        `${Key.domain}/submission/get_submission_history`,
        {
          candidateid: submission.candidate_id,
          jobid: submission.job_id,
        }
      );
      //console.log("results---", result.data.data);
      const historyData = Array.isArray(result.data.data.jobHistory) ? result.data.data.jobHistory : [];
      //console.log("historyData", historyData)
      setHistory(historyData);
      setShowHistory(true);
      setSelectedJobInfo(result.data.data.submissions[0]);
    } catch (error) {
      console.error("Error fetching submission history:", error);
      setHistory([]);
    } finally {
      setLoadingHistory((prev) => ({ ...prev, [loadingKey]: false }));
    }
  };

  const handleBack = () => {
    setShowHistory(false);
    setHistory([]);
    setSelectedJobInfo({});
  };

  const isHistoryLoading = (candidateid, jobid) => {
    const key = `${candidateid}-${jobid}`;
    return loadingHistory[key] || false;
  };
  const getBorderColor = (newStatus) => {
    if (!newStatus) return "#1976d2";

    const status = Number(newStatus);
    if (status >= 7) return "#81c784";
    if (status === 6) return "#ff9800";
    if (status === 5) return "#1976d2";
    if (status <= 3) return "#9e9e9e";

  };

  const filteredCandidates = assignedCandidates.filter(
    (candidate) => candidate.status === 1
  );

  return (
    <div>
      <Box>
        {!showHistory ? (
          <InfiniteScroll
            dataLength={visibleSubmissions.length}
            next={fetchMoreData}
            hasMore={hasMore}
            style={{ overflowY: "scroll", overflowX: "hidden" }}
          >
            {!candidateSubmissions ||
              filteredCandidates.length < 1 ||
              !myRecruiters ||
              !assignedCandidates ||
              visibleSubmissions.length === 0 ? (
              <Typography
                variant="body1"
                align="center"
                style={{ margin: "10px", fontSize: "12px" }}
              >
                No submissions yet for this contact
              </Typography>
            ) : (
              visibleSubmissions.map((submission, index) => {
                const isLoading = isHistoryLoading(
                  submission?.candidate_id,
                  submission?.job_id
                );

                return (
                  <div
                    key={submission?.submission_id ?? submission?.id ?? index}
                  >
                    <ListItemButton
                      sx={{
                        margin: "0px",
                        ".hide-icons": { display: "none" },
                        "&:hover": { ".hide-icons": { display: "block" } },
                      }}
                      onClick={() => handleSelection(submission)}
                    >
                      <div style={{ display: "flex", gap: 10, width: "100%" }}>
                        <Avatar
                          sx={{
                            height: isDesktopLarge ? "40px" : "35px",
                            width: isDesktopLarge ? "40px" : "35px",
                          }}
                        >
                          <BusinessCenterRounded
                            sx={{
                              color: "#fff",
                              height: isDesktopLarge ? "20px" : "20px",
                              width: isDesktopLarge ? "20px" : "20px",
                            }}
                          />
                        </Avatar>
                        <Stack direction="column" sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                            }}
                          >
                            <Tooltip title={submission?.jobtitle} placement="top">
                              <Typography
                                sx={{
                                  fontSize: isDesktopLarge ? "12px" : "10px",
                                  fontWeight: 600,
                                  margin: 0,
                                  minWidth: isDesktopLarge ? "190px" : "120px",
                                  maxWidth: isDesktopLarge ? "190px" : "120px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {submission?.jobtitle}
                              </Typography>
                            </Tooltip>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                            }}>
                            <Typography
                              sx={{
                                fontSize: isDesktopLarge ? "12px" : "9px",
                                margin: 0,
                                textTransform: "capitalize",
                              }}
                            >
                              {submission?.company_name || "N/A"}
                            </Typography>
                            <Tooltip title={isLoading ? "Loading..." : "History"}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: 24,
                                  height: 24,
                                  cursor: isLoading ? "default" : "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!isLoading) {
                                    getSubmissionsHistory(submission);
                                  }
                                }}
                              >
                                {isLoading ? (
                                  <CircularProgress
                                    size={18}
                                    thickness={4}
                                    style={{ color: "#1976d2" }}
                                  />
                                ) : (
                                  <HistoryIcon
                                    fontSize="small"
                                    style={{
                                      color: "#9e9e9e",
                                      opacity: 0.8,
                                    }}
                                  />
                                )}
                              </Box>
                            </Tooltip>
                          </Box>
                        </Stack>
                      </div>
                    </ListItemButton>
                  </div>
                );
              })
            )}
          </InfiniteScroll>
        ) : (
          <Grid container spacing={1} style={{ padding: "10px" }}>
            {!Array.isArray(history) || history.length === 0 ? (
              <Grid item xs={12}>
                <KeyboardBackspaceRoundedIcon
                  onClick={handleBack}
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: 18, sm: 20 },
                    flexShrink: 0,
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  style={{ margin: "10px", fontSize: "12px" }}
                >
                  No history found for this submission
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Paper
                  elevation={2}
                  style={{
                    padding: "15px",
                    borderRadius: "8px",
                  }}
                >
                  <Box sx={{ mb: 2, pb: 2, borderBottom: "1px solid #e0e0e0" }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    >
                      <KeyboardBackspaceRoundedIcon
                        onClick={handleBack}
                        sx={{
                          cursor: "pointer",
                          fontSize: { xs: 18, sm: 20 },
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: { xs: "13px", sm: "14px" },
                          fontWeight: 600,
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1,
                          minWidth: 0,
                          "&:hover": {
                            color: "#1a73e8",
                            textDecoration: "underline",
                            cursor: "pointer",
                          },
                        }}
                        onClick={(e) => {
                          // stop the parent ListItem onClick
                          e.stopPropagation();

                          // 1) dispatch to fetch & store job details
                          const jobId = selectedJobInfo?.job_id ?? selectedJobInfo?.job?.id;
                          if (jobId) {
                            dispatch(getJobDetailsAction(jobId));
                          } else {
                            console.warn("No job id found for submission", selectedJobInfo);
                          }
                          const payload = {
                            jobId: jobId || null,
                            companyName: selectedJobInfo?.company_name || null,
                            candidateId: selectedJobInfo?.candidate_id || null,
                            jobTitle: selectedJobInfo?.jobtitle || null,
                          };

                          if (typeof handleCompanyClick === "function") {
                            handleCompanyClick(payload);
                          }
                        }}
                      >
                        {selectedJobInfo.jobtitle || "Submission History"}
                      </Typography>
                    </Box>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: { xs: "11px", sm: "12px" },
                        color: "#5f6368",
                        mt: 0.5,
                        ml: 3,
                      }}
                    >
                      {selectedJobInfo.company_name}
                    </Typography>
                  </Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontSize: { xs: "11px", sm: "12px" },
                      fontWeight: 600,
                      color: "#5f6368",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: 0,
                      paddingBottom: 2
                    }}
                  >
                    <span style={{ opacity: 0.8 }}>Resume:</span>
                    <span
                      style={{
                        fontWeight: 700,
                        color: "#1a73e8",
                        textDecoration: "underline",
                        textUnderlineOffset: "2px",
                      }}
                    >
                      {selectedJobInfo?.filename || "Not available"}
                    </span>
                  </Typography>

                  <Box sx={{ position: "relative" }}>
                    {history.map((item, index) => {
                      const borderColor = getBorderColor(item?.new_status);

                      return (
                        <Box
                          key={item?.id || index}
                          sx={{
                            position: "relative",
                            pl: 3,
                            pb: index !== history.length - 1 ? 2 : 1,
                          }}
                        >
                          {index !== history.length - 1 && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: 6,
                                top: 14,
                                bottom: -8,
                                borderLeft: "1px dashed rgba(0,0,0,0.3)",
                              }}
                            />
                          )}
                          <Box
                            sx={{
                              position: "absolute",
                              left: 0,
                              top: 6,
                              width: 12,
                              height: 12,
                              borderRadius: "50%",
                              border: `2px solid ${borderColor}`,
                              backgroundColor: "#fff",
                              zIndex: 1,
                              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            }}
                          />
                          <Box
                            sx={{
                              backgroundColor: "#f9f9f9",
                              borderRadius: "6px",
                              padding: "8px 10px",
                              border: "1px solid #f0f0f0",
                            }}
                          >
                            <Stack direction="column" sx={{ width: "100%" }}>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  m: 0,
                                  lineHeight: 1.2,
                                  color: "#3c4043",
                                }}
                              >
                                {item?.comment || "Status Update"}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: "10px",
                                  color: "#5f6368",
                                  m: 0,
                                  lineHeight: 1.2,
                                  marginTop: "2px",
                                }}
                              >
                                Handled by: {item?.handled_by || "N/A"}
                              </Typography>

                              {item?.created_at && (
                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    color: "#9e9e9e",
                                    marginTop: "4px",
                                  }}
                                >
                                  {moment(item.created_at).format(
                                    "MMM DD, YYYY hh:mm A"
                                  )}
                                </Typography>
                              )}

                              {item?.interview_date && item?.interview_time && (
                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    color: "#1976d2",
                                    marginTop: "4px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Interview: {item.interview_time} | {item.interview_date}
                                </Typography>
                              )}
                            </Stack>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Paper>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default AdminRecruiterSubmissions;